import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import MarkAsReadButton from "../../../khattabat-clients/conversation/body/side-actions/MarkAsReadButton";
import EnableDisableConversation from "../../shared/EnableDisableConversation";
import HighlightOneOOneM from "../../shared/HighlightOneOOneM";
import IgnoreConversation from "../../shared/IgnoreConversation";

const SideActions = withLiteObserverAndTheme<{
  matchID: number;
  matchStatus: string;
  alkhattabaUUID: string;
  matchUUID: string;
  matchUnreadMessages: number;
  matchConvesationIsDisabled: boolean;
  conversationID: string;
  isHighlighted: boolean;
  matchHasDeletedTheConversation: boolean;
}>((props) => {
  const {
    matchID,
    matchStatus,
    alkhattabaUUID,
    matchUUID,
    matchUnreadMessages,
    matchConvesationIsDisabled,
    conversationID,
    isHighlighted,
    matchHasDeletedTheConversation,
    theme
  } = props;
  const { unitY, colors } = theme;
  const isActiveMatch = matchStatus === "active";
  const statusColor = isActiveMatch ? colors.all.green : colors.all.red;
  return (
    <ET3Div
      width={200}
      height={200}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      {!matchHasDeletedTheConversation ? null : (
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          isSpan={true}
          text={i18n.get("DELETED_BY_MATCH")}
          style={{
            height: 30 * unitY,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            color: statusColor
          }}
          color={""}
        />
      )}
      <MarkAsReadButton
        unreadOneOOneCMessages={matchUnreadMessages}
        alkhattabaUUID={alkhattabaUUID}
        clientUUID={matchUUID}
        clientID={matchID}
        pageType={"matchResultPage"}
        conversationType={"101M"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        isSpan={true}
        text={matchStatus}
        style={{
          height: 30 * unitY,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          color: statusColor
        }}
        color={""}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <EnableDisableConversation
        isDisabled={matchConvesationIsDisabled}
        matchID={matchID}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <IgnoreConversation matchIDs={[matchID]} pageType={"matchResultPage"} />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <HighlightOneOOneM
        isHighlighted={isHighlighted}
        conversationID={conversationID}
        matchID={matchID}
      />
    </ET3Div>
  );
});

export default SideActions;
